export default {
  landing: {
    askSection: {
      heading: 'Ask about our dedicated offer for',
      subheading: 'Colleges and Academies',
      formLink: 'Contact our consultant for details',
    },
  },
};
